// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"94":"43a675c2","605":"5986ef38","753":"17c21a8d","981":"f24d78ca"}[chunkId] + ".chunk.js";
};